import React from 'react';
import _ from 'lodash';
import { Checkbox } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import toastr from 'toastr';
import apiService from '../../service/apiService';

import { rruleObjtoStringwithCurrentTimeasStartTime, rruleStringTorruleObj } from '../../HelperMethods/TaskUtilities';
import { stopPageLoading, startPageLoading, types } from '../taskView/TaskViewPage/redux/reducer';

const CheckboxExampleToggle = ({ ...props }) => {
  const dispatch = useDispatch();
  const [endTime, setEndTime] = React.useState('');
  const [toggle, setToggle] = React.useState(true);
  React.useEffect(() => {
    const data = _.get(props, 'data', {});
    const recurrenceInactive = _.get(props, 'data.recurrenceInactive', false);

    setToggle(!recurrenceInactive);
    if (!_.isEmpty(props) && !_.isEmpty(data)) {
      const endTimeData = _.get(data, 'endDate');
      setEndTime(endTimeData);
    }
  }, []);

  async function updateTask(taskObj) {
    dispatch(startPageLoading());
    const taskResponse = await apiService.upsertTask(taskObj);
    dispatch(stopPageLoading());
    dispatch({ type: types.UPDATE_TASK_TIME_DIRTY_STATE, updateTaskObj: taskObj });
    return _.get(taskResponse, 'recurrenceInactive', false) || false;
  }
  React.useEffect(() => {}, [toggle]);

  const onToggleChange = async (toggleState) => {
    // setToggle(async (prevState) => {
    const current = moment();

    const endTimeDate = moment(endTime);

    if (!_.isEmpty(props)) {
      const id = _.get(props, 'data.id', '');

      try {
        // making task active to inactive
        if (!_.isEmpty(id) && toggleState) {
          const taskToBeUpdated = {
            id,
            recurrenceInactive: toggle,
          };

          const recurrenceInactive = await updateTask(taskToBeUpdated);

          // update locally
          if (recurrenceInactive) {
            setToggle(() => !recurrenceInactive);
            // return !recurrenceInactive;
          }
        }
        // making task inactive to active
        if (!_.isEmpty(id) && !toggleState) {
          const rruleObject = rruleStringTorruleObj(props.data);
          const updatedrrule = rruleObjtoStringwithCurrentTimeasStartTime(rruleObject);
          if (!current.isBefore(endTimeDate, 'd') && !current.isBefore(endTimeDate, 'h')) {
            throw new Error('End Date of the Task has Passed');
          }
          const taskToBeUpdated = {
            id,
            recurrenceInactive: toggleState,
            rrule: updatedrrule,
          };
          const recurrenceInactive = await updateTask(taskToBeUpdated);

          if (!recurrenceInactive) {
            setToggle(() => !recurrenceInactive);

            // return !recurrenceInactive;
          }
        }
      } catch (e) {
        toastr.error(e);
        console.error(e);

        setToggle((_prevState) => _prevState);
      }
    }
    // });
    // return setToggle(!toggle);
    // });
  };

  return <Checkbox className="green-color" toggle checked={toggle} onChange={() => onToggleChange(toggle)} />;
};

export default CheckboxExampleToggle;
